import { nextTick } from 'vue'

/**
 * Wait for the next display frame (vsync). Lets CSS animations (e.g. PrimeVue ProgressSpinner) advance.
 */
export function yieldAnimationFrame(): Promise<void> {
  return new Promise((resolve) => {
    requestAnimationFrame(() => resolve())
  })
}

/**
 * After Vue updates the DOM (spinner / overlay), give the browser time to **paint** before blocking
 * the main thread with synchronous work (maps, large sync JS, etc.).
 *
 * `nextTick` alone runs after DOM updates but often **before** paint; one `rAF` can still run before
 * paint in some cases. Sequence: microtask (Vue) → macrotask → next frame.
 */
export async function yieldUntilSpinnerPainted(): Promise<void> {
  await nextTick()
  await new Promise<void>((r) => setTimeout(r, 0))
  await yieldAnimationFrame()
}
